import { payloadExtractor } from 'app-webtech-core/reducers/payloadExtractor';
import { updateState } from 'app-webtech-core/reducers/updateState';

const mutationGenerator = () => ({
  expanded: { $set: false },
});

export const guideShrinkReducer = (currentState, action) =>
  updateState(currentState, mutationGenerator(payloadExtractor(action)));
